import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { type AnimationClip, AnimationMixer, type Group } from 'three/webgpu';

export interface LoadedCharacter {
  readonly root: Group;
  readonly mixer: AnimationMixer;
  readonly clips: readonly AnimationClip[];
}

/**
 * Load a rigged character (e.g. a Mixamo export converted to GLB) and start
 * its first animation clip. Returns null when the file does not exist or
 * cannot be parsed, so callers can fall back to the placeholder dancer.
 */
export async function tryLoadCharacter(url: string): Promise<LoadedCharacter | null> {
  try {
    const gltf = await new GLTFLoader().loadAsync(url);
    const mixer = new AnimationMixer(gltf.scene);
    const firstClip = gltf.animations[0];
    if (firstClip !== undefined) {
      mixer.clipAction(firstClip).play();
    }
    return { root: gltf.scene, mixer, clips: gltf.animations };
  } catch {
    return null;
  }
}
